<template>
  <a-modal
          title="专家信息"
          okText="确认"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="12">
          <a-form-model-item  label="专家姓名" prop="name">
            <a-input v-model="formState.name"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="性别" prop="sex">
            <a-ext-local-dic-select dic-key="Sex" v-model="formState.sex"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="出生年月" prop="both">
            <a-ext-data-picker v-model="formState.both"></a-ext-data-picker>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属单位" prop="org">
            <a-input v-model="formState.org"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="职位" prop="level">
            <a-ext-local-dic-select dic-key="OfferLevel" v-model="formState.level"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="办公电话" prop="tel">
            <a-input v-model="formState.tel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="手机" prop="mobile">
            <a-input v-model="formState.mobile"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtDataPicker from '../../../components/AntDesignExt/All/AExtDataPicker'
import {addorUpdateProfessor as saveApi,getProfessorById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtLocalDicSelect,AExtDataPicker,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                name:'',
                sex:'',
                both:'',
                gov:'',
                level:'',
                tel:'',
                mobile:'',
            },
            rules: {
                name: FormRules.withName('专家姓名').string(1, 200).isRequired().create(),
                tel:FormRules.withName('办公电话').string(1, 20).create(),
                mobile:FormRules.withName('手机号').phone().create()
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("addProfessorClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>